import {
  StaffPerformanceReview,
  ReviewStatus,
  PerformanceRating,
  StaffDepartment,
  PerformanceSummary,
} from '../../views/modules/analytics/performance/performance.interfaces';

export const mockStaffPerformanceReviews: StaffPerformanceReview[] = [
  {
    id: 'staff-1',
    staffId: 'STAFF001',
    employeeId: 'EMP001',
    name: 'Dr. Priya Sharma',
    department: StaffDepartment.TEACHING,
    position: 'Senior Mathematics Teacher',
    joiningDate: '2018-06-15',
    supervisor: 'Mrs. Sunita Agarwal (Head of Mathematics)',
    reviewPeriod: 'Annual 2024',
    reviewDate: '2024-07-10',
    reviewer: 'Dr. Rajesh Kumar (Principal)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.EXCELLENT,
    overallScore: 93,
    comments:
      'Dr. Sharma consistently delivers exceptional teaching performance.',
    strengths: ['Excellent teaching methodology', 'Strong student engagement'],
    areasForImprovement: ['Technology integration', 'Administrative tasks'],
    goals: [
      'Complete digital teaching certification',
      'Lead curriculum revision',
    ],
    nextReviewDate: '2025-07-10',
    kpis: [
      {
        metric: 'Student Pass Rate',
        target: 85,
        achieved: 94,
        percentage: 110.6,
        rating: PerformanceRating.EXCELLENT,
      },
    ],
    competencies: [
      {
        competency: 'Subject Matter Expertise',
        rating: PerformanceRating.EXCELLENT,
        description: 'Deep knowledge of mathematics',
      },
    ],
    professionalDevelopment: {
      trainingCompleted: ['Advanced Pedagogy Workshop'],
      certifications: ['Cambridge Teaching Certification'],
      skillsAcquired: ['Differentiated instruction techniques'],
    },
    careerGoals: ['Become Head of Mathematics Department'],
    promotionRecommendation: true,
    salaryReviewRecommendation: true,
  },
  {
    id: 'staff-2',
    staffId: 'STAFF002',
    employeeId: 'EMP002',
    name: 'Mr. Amit Patel',
    department: StaffDepartment.ADMINISTRATION,
    position: 'Finance Manager',
    joiningDate: '2020-03-20',
    supervisor: 'Mrs. Kavita Singh (Business Manager)',
    reviewPeriod: 'Annual 2024',
    reviewDate: '2024-07-15',
    reviewer: 'Mrs. Kavita Singh (Business Manager)',
    status: ReviewStatus.COMPLETED,
    overallRating: PerformanceRating.GOOD,
    overallScore: 81,
    comments: 'Mr. Patel demonstrates strong financial management skills.',
    strengths: ['Strong analytical skills', 'Process improvement'],
    areasForImprovement: ['Report presentation skills', 'Software proficiency'],
    goals: ['Implement new financial software', 'Complete CPA certification'],
    nextReviewDate: '2025-07-15',
    kpis: [
      {
        metric: 'Budget Accuracy',
        target: 95,
        achieved: 97,
        percentage: 102.1,
        rating: PerformanceRating.EXCELLENT,
      },
    ],
    competencies: [
      {
        competency: 'Financial Analysis',
        rating: PerformanceRating.EXCELLENT,
        description: 'Excellent financial analysis',
      },
    ],
    professionalDevelopment: {
      trainingCompleted: ['Advanced Excel Workshop'],
      certifications: ['Certified Management Accountant (CMA)'],
      skillsAcquired: ['Advanced data analysis'],
    },
    careerGoals: ['Complete CPA certification'],
    promotionRecommendation: false,
    salaryReviewRecommendation: true,
  },
];

export const mockStaffPerformanceSummary: PerformanceSummary = {
  totalReviews: 2,
  completedReviews: 2,
  pendingReviews: 0,
  overdueReviews: 0,
  averageRating: 8.7,
  ratingDistribution: {
    excellent: 1,
    good: 1,
    satisfactory: 0,
    needsImprovement: 0,
    unsatisfactory: 0,
  },
};
